import React, { useEffect, useState } from "react";
import { Grid, useMediaQuery } from "@mui/material";

import { useNavigate } from "react-router-dom";
import TableGeneric from "../../components/Generics/TableGeneric";
import { Projeto } from "../../model/entities/Projeto";
import projetoApi from "../../api/projetoApi";
import ButtonGeneric from "../../components/Generics/ButtonGeneric";
import { PlusCircle } from "@phosphor-icons/react";
import { useSnack } from "../../redux/snack/snackHooks";
import InfoTabela from "../../components/Generics/InfoTabela";
import theme from "../../theme";

const columns: Projeto[] | any[] = [
  {
    field: "id",
    headerName: "id",
    width: 5,
    editable: false,
  },
  {
    field: "nome",
    headerName: "Nome",
    width: 230,
    editable: false,
  },
  {
    field: "nomeCliente",
    headerName: "Cliente",
    width: 230,
    editable: false,
  },
];

const ListagemProjetoPage: React.FC = () => {
  const [clientes, setClientes] = useState<Projeto[]>([]);
  const [totalLinhas, setTotalLinhas] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [pagina, setPagina] = useState(0);
  const [linhasPorPagina, setLinhasPorPagina] = useState(5);
  const mostrarSnack = useSnack();
  const isSmallSScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [projetoSelecionado, setProjetoSelecionado] = useState<Projeto | null>(
    null
  );

  useEffect(() => {
    buscarProjetos();
  }, []);
  useEffect(() => {
    if (projetoSelecionado && projetoSelecionado.id) {
      navigate(`/projeto/completo/${projetoSelecionado.id}`);
    }
  }, [projetoSelecionado]);

  const buscarProjetos = async () => {
    try {
      setLoading(true);
      const count = await projetoApi.count();
      setTotalLinhas(count);

      const res = await projetoApi.getMany(pagina, linhasPorPagina);
      setClientes(res);
      setLoading(false);
    } catch (erro: any) {
      mostrarSnack(
        "Ops, aconteceu um problema ao buscar os projtos!!",
        "error"
      );
      console.log("Erro ao buscar clientes", erro);
      setLoading(false);
    }
  };

  useEffect(() => {
    buscarProjetos();
  }, [pagina, linhasPorPagina]);

  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={12}
        md={6}
        style={{ textAlign: isSmallSScreen ? "center" : "left" }}
      >
        <InfoTabela mensagem="Para detalhes do projeto clique no mesmo" />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
        style={{ textAlign: isSmallSScreen ? "center" : "right" }}
      >
        <ButtonGeneric
          endIcon={<PlusCircle />}
          label={"Cadastrar novo projeto"}
          onClick={() => {
            navigate(`/projeto/cadastro`);
          }}
        ></ButtonGeneric>
      </Grid>

      <Grid item xs={12}>
        <TableGeneric
          pageSize={linhasPorPagina}
          colunas={columns}
          linhas={clientes}
          loading={loading}
          totalLinhas={totalLinhas}
          selecionaLinha={false}
          formasDeListar={[5, 10]}
          onRowClick={(row) => setProjetoSelecionado(row.row)}
          sx={{ height: "400px" }}
          stringLinhaVazia="Nenhum projeto encontrado"
          setPaginacao={(model) => {
            setPagina(model.page);
            setLinhasPorPagina(model.pageSize);
          }}
        />
      </Grid>
    </Grid>
  );
};

export default ListagemProjetoPage;
